import React from 'react'
import FlightControl from '../../flight/FlightControl'
import V3DataRouteShell from '../data/V3DataRouteShell'

export default function V3FlightControlPage() {
  return (
    <V3DataRouteShell>
      <FlightControl />
    </V3DataRouteShell>
  )
}

